export default "__VITE_ASSET__OKEml5WQ__"